import React from 'react';
import {
  StyledMain,
  StyledMessage,
  StyledMessageButtons,
  StyledMessageButton,
  StyledBeadcrumb,
  StyledBeadcrumbIcon,
  StyledBeadcrumbPrimary,
  StyledAccountConfirm,
  StyledAccountConfirmIcon,
  StyledAccountConfirmTxt,
  StyledAccountConfirmButton,
  StyledModal,
  StyledFormColumns,
  StyledFormColumn,
  StyledInput
} from './style';
import Button from '../../../core/Buttons';
import Icon from '../../../core/Icon';
import {
  Trash,
  Pencil,
  Arrow,
  Success,
  ArrowLeft
} from '../../../../../assets/images/index';

import { bankAccount } from '../../../../utils/mocks/js';
import { BankAccountForm } from './bankAccountForm';

const UploadConfirm = ({ onClick, title, txt }) => (
  <StyledAccountConfirm>
    <StyledAccountConfirmIcon color="dark" svg={Success} />
    <StyledAccountConfirmTxt>{title}</StyledAccountConfirmTxt>
    <StyledAccountConfirmTxt>{txt}</StyledAccountConfirmTxt>
    <StyledAccountConfirmButton transparent secondary onClick={onClick}>
      <Icon svg={ArrowLeft} size="xs" />
      {bankAccount.bankAccountConfirm.btn}
    </StyledAccountConfirmButton>
  </StyledAccountConfirm>
);

const TwoLevelBreadcrumb = ({ first, second, onBack, className }) => (
  <StyledBeadcrumb className={className}>
    <span
      onClick={() => {
        onBack();
      }}
      onKeyUp={() => {}}
      role="button"
      tabIndex="0"
    >
      {first}
    </span>
    <StyledBeadcrumbIcon color="dark" size="m" svg={Arrow} />
    <StyledBeadcrumbPrimary>{second}</StyledBeadcrumbPrimary>
  </StyledBeadcrumb>
);

const BankAccountMessage = ({ onEdit, onDelete }) => (
  <StyledMessage>
    {bankAccount.bankAccountPending}
    <StyledMessageButtons>
      <StyledMessageButton transparent onClick={onDelete}>
        <Icon color="dark" size="m" svg={Trash} />
      </StyledMessageButton>
      <StyledMessageButton transparent onClick={onEdit}>
        <Icon color="dark" size="m" svg={Pencil} />
      </StyledMessageButton>
    </StyledMessageButtons>
  </StyledMessage>
);

const BankAccountModal = ({ onAccept, onCancel }) => (
  <StyledModal title="ELIMINAR SOLICITUD" clickCloseIcon={onCancel}>
    <p>¿Confirmas que quieres eliminar la solicitud?</p>
    <Button modal onClick={onCancel}>
      Cancelar
    </Button>
    <Button secondary onClick={onAccept}>
      Aceptar
    </Button>
  </StyledModal>
);

const SectionWrapper = ({ children }) => <StyledMain>{children}</StyledMain>;

const FormColumns = ({ children, className }) => (
  <StyledFormColumns className={className}>{children}</StyledFormColumns>
);

const FormColumn = ({
  className,
  mobile = '100%',
  tablet = '50%',
  desktop = tablet,
  children
}) => (
  <StyledFormColumn
    className={className}
    mobile={mobile}
    tablet={tablet}
    desktop={desktop}
  >
    {children}
  </StyledFormColumn>
);

const Input = ({ className, small = false, ...rest }) => (
  <StyledInput className={className} small={small} {...rest} />
);

export {
  SectionWrapper,
  BankAccountMessage,
  TwoLevelBreadcrumb,
  BankAccountForm,
  UploadConfirm,
  BankAccountModal,
  FormColumns,
  FormColumn,
  Input
};
